module.exports = __webpack_public_path__ + "img/IMG_5914.19e0f522.jpg";